/**
 * What a sign-in was made on — one answer, shared.
 *
 * "Chrome on Windows" is what a person needs to recognise a session as theirs
 * or not, and the raw user-agent string is what a browser sends. Something has
 * to turn one into the other, and until now that something lived inside
 * `pages/account.tsx` where only that screen could reach it. The admin activity
 * feed (`docs/rowted-admin-v2.md` §2.7) needs the same sentence, and two
 * versions of it would eventually disagree about what an iPad is.
 *
 * **Deliberately not a parser.** `ua-parser-js` keeps a database of hundreds of
 * devices, updates it monthly, and answers a question nobody here is asking.
 * The question here is "is one of these not me", and a handful of substrings
 * answers it. What it gets wrong it gets wrong harmlessly — an unrecognised
 * browser reads "A browser", never something confidently false.
 */
const UNKNOWN = {
    browser: 'A browser', device: 'an unknown device', text: 'Unknown device',
};
export function agentFacts(agent) {
    if (!agent)
        return UNKNOWN;
    /*
     * Order matters in both lists, because these strings nest: every Chrome
     * user-agent also says Safari, and Edge says both. Most specific first.
     */
    const browser = /Edg\//.test(agent) ? 'Edge'
        : /OPR\//.test(agent) ? 'Opera'
            : /Chrome\//.test(agent) ? 'Chrome'
                : /Firefox\//.test(agent) ? 'Firefox'
                    : /Safari\//.test(agent) ? 'Safari' : 'A browser';
    const device = /iPhone/.test(agent) ? 'iPhone'
        : /iPad/.test(agent) ? 'iPad'
            : /Android/.test(agent) ? 'Android'
                : /Mac OS X/.test(agent) ? 'a Mac'
                    : /Windows/.test(agent) ? 'Windows'
                        : /Linux/.test(agent) ? 'Linux' : 'an unknown system';
    return { browser, device, text: `${browser} on ${device}` };
}
/** The one-line form, which is what most callers want. */
export const describeAgent = (agent) => agentFacts(agent).text;
//# sourceMappingURL=user-agent.js.map